import { render, staticRenderFns } from "./speechcraft.vue?vue&type=template&id=278e2ea7&scoped=true"
import script from "./speechcraft.vue?vue&type=script&lang=js"
export * from "./speechcraft.vue?vue&type=script&lang=js"
import style0 from "./speechcraft.vue?vue&type=style&index=0&id=278e2ea7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278e2ea7",
  null
  
)

export default component.exports